import {
  IsBoolean,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';

export class TaxCodeResultDto {
  @IsNotEmpty()
  @IsUUID(4)
  id!: string;

  @IsNotEmpty()
  @IsString()
  name!: string;

  @IsOptional()
  @IsString()
  abbreviation?: string;

  @IsNotEmpty()
  @IsNumber()
  taxRatio!: number;

  @IsOptional()
  @IsString()
  taxRatioExplanation?: string;

  @IsNotEmpty()
  @IsBoolean()
  displayTaxRatioExplanation!: boolean;

  @IsNotEmpty()
  @IsUUID(4)
  countryId!: string;

  @IsNotEmpty()
  @IsString()
  countryName!: string;

  @IsNotEmpty()
  @IsString()
  countryIsoCode!: string;

  @IsNotEmpty()
  @IsString()
  countryIsoCode3!: string;

  @IsOptional()
  @IsString()
  paragraph?: string;
}

export class CountryResultDto {
  @IsNotEmpty()
  @IsUUID(4)
  id!: string;
  @IsNotEmpty()
  @IsString()
  isoCode!: string;
  @IsNotEmpty()
  @IsString()
  isoCode3!: string;
  @IsNotEmpty()
  @IsNumber()
  numericCode!: number;
  @IsNotEmpty()
  @IsString()
  name!: string;
  @IsNotEmpty()
  @IsString()
  fullName?: string;
}

export const CountriesTaxCodesControllerDefinition = {
  controller: 'countries',
  endpoints: {
    getTaxCodes: {
      method: 'GET',
      url: ':countryId/tax-codes',
      response: undefined as unknown as TaxCodeResultDto[],
      body: undefined,
      query: undefined,
    },
    getCountries: {
      method: 'GET',
      url: '',
      response: undefined as unknown as CountryResultDto[],
      body: undefined,
      query: undefined,
    },
  },
} as const;

export type CountriesTaxCodesControllerResultTypes = {
  [key in keyof (typeof CountriesTaxCodesControllerDefinition)['endpoints']]: (typeof CountriesTaxCodesControllerDefinition)['endpoints'][key]['response'];
};
export type CountriesTaxCodesControllerQueryTypes = {
  [key in keyof (typeof CountriesTaxCodesControllerDefinition)['endpoints']]: (typeof CountriesTaxCodesControllerDefinition)['endpoints'][key]['query'];
};
export type CountriesTaxCodesControllerBodyTypes = {
  [key in keyof (typeof CountriesTaxCodesControllerDefinition)['endpoints']]: (typeof CountriesTaxCodesControllerDefinition)['endpoints'][key]['body'];
};
